var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-form-field-error"},[_c(_setup.BCXMarkdown,{staticClass:"bcx-error-text c-form-input-error",attrs:{"tag":"div","text":_setup.errorMarkdown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }